module.exports = __webpack_public_path__ + "img/arrow-up.638e9753.svg";